module.exports = __webpack_public_path__ + "img/item_2.71295724.png";